import React from 'react';
import { Bar } from 'react-chartjs-2';

const EmotionsRecognition = () => {
    const data = {
        labels: ['Joy', 'Fear', 'Sadness', 'Anger', 'Surprise', 'Disgust'],
        datasets: [
            {
                data: [420, 380, 300, 400, 405, 295],
                backgroundColor: ['#FCEBA2', '#90BCB5', '#C7DDDA', '#F4B3AE', '#F6CBA0', '#C38F8B'],
                barThickness: 40,
                borderRadius: {
                    topLeft: 10,
                    topRight: 10,
                    bottomLeft: 10,
                    bottomRight: 10,
                },
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                display: false
            }
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    font: {
                        family: 'Manrope',
                    },
                    color: '#AFAFAF',
                },
            },
            y: {
                grid: {
                    display: false,
                },
                ticks: {
                    font: {
                        family: 'Manrope',
                    },
                    color: '#AFAFAF',
                },
            },
        },
        responsive: true,
        maintainAspectRatio: false,
    };

    const chartStyles = {
        boxShadow: '10px 10px 80px -15px #E7E4E899',
        height: '300px',
        borderRadius: '20px',
        padding: '2rem',
        width: '100%',
    };

    return (
        <div className='w-full lg:w-[70%]' style={chartStyles}>
            <Bar data={data} options={options} />
        </div>
    );
};

export default EmotionsRecognition;